@if(currentMaxWindKtS() >= galeWarningThresholdKt) {
<button type="button"  mat-icon-button color="warn"
    aria-label="Sturm-Warnung" (click)="presentGaleWarning()">
    <i class="wi weather-icon" [ngClass]="galeWarningIconS()">
    </i>
</button>
}